export const ROUTE_DASHBOARD = "/dashboard";
export const ROUTE_CHAT = "/chat";
export const ROUTE_QUIZ = "/quiz";
export const ROUTE_LOGIN = "/";
export const ROUTE_SIGN_UP = "/sign-up";
export const ROUTE_CHECK_MAIL = "/check-mail";
export const ROUTE_INFO_SUCCESS = "/info-success";
export const ROUTE_NEW_LOGIN = "/login";
export const ROUTE_ACCOUNT_CREATE = "/account-create";
export const ROUTE_PERSONAL_JOURNEY = "/personal-journey";
export const ROUTE_AI_GENERATE = "/ai-generate";
export const ROUTE_DESCRIPTIVE = "/descriptive";
export const ROUTE_AI_ANALYSIS = "/analysis";
export const ROUTE_PROFILE = "/profile";
export const ROUTE_PAYMENT_SUCCESS = "/payment-success";
// Admin App Routes (root level routes for admin app)
export const ROUTE_STUDENT_MANAGEMENT = "/student-management";
export const ROUTE_SCHOOL_MANAGEMENT = "/school-managament";
export const ROUTE_TEACHER_MANAGEMENT = "/teacher-managament";
export const ROUTE_ASPIRANT_MANAGEMENT = "/aspirant-managament";
export const ROUTE_LEARNING_ASSETS = "/learning-assets";
export const ROUTE_ADMIN_COMPETITIVE_EXAM = "/admin-competitive-exam";
export const ROUTE_ADMIN_QUIZ = "/admin-quiz";
export const ROUTE_ADMIN_LIVE_QUIZ = "/admin-live-room";
export const ROUTE_ADMIN_QUIZ_PLAY = "/admin-quiz-play";
export const ROUTE_ADMIN_ASYNC_QUIZ_ROOM = "/admin-async-quiz-room";
export const ROUTE_ADMIN_QUIZ_HISTORY = "/admin-quiz-history";
export const ROUTE_ADMIN_ROUND_RESULTS = "/admin-round-results";
export const ROUTE_ADMIN_LEADER_BOARD = "/admin-leader-board";
export const routeToMCQ = (subject) => `${ROUTE_QUIZ}?subject=${subject}`;
export const ROUTE_COMPETITIVE_EXAM = "/competitive-exam";
export const routeEvalutionToQuiz = (subject, chapter, medium) =>
  `${ROUTE_QUIZ}?subject=${subject}&chapter=${chapter}&medium=${medium}`;
export const ROUTE_MOCK_TEST = "/mock-test";
export const ROUTE_SUCCESS_PAGE = "/success";
